export const P01_05 = {
    "columns": 6,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "bar",
        "title": "Top 10 Product Sales",
        "colorTheme": 'colorTheme2',
        "orientation": "horizontal",
        "xAxis": "Sales",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Sales',
                        "value": 'ActualSales',
                        "type": 'column'
                    }
                ],
                "title": "ItemName",
                "endpoint": "P01.5",
                "parameters": [
                    { "key": "FromMonth", "value": "" },
                    { "key": "FromYear", "value": "" },
                    { "key": "ToMonth", "value": "" },
                    { "key": "ToYear", "value": "" },
                    { "key": "DistributorCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": { }
                }
            }
        }
    }
}